import React from "react";
import "./App.css";
import { Switch, Route } from 'react-router-dom';
import { BrowserRouter  } from 'react-router-dom';
import PimaUpload from "./components/pages/PimaUpload";

function App() {
  /*console.log(process.env.NODE_ENV);

  console.log(process.env.REACT_APP_API_HOTSEARCH);

  console.log(process.env.REACT_APP_API_UPLOAD);
  
  console.log(process.env.REACT_APP_API_AUTH);
  
  console.log(process.env.REACT_APP_API_SUBMITMAPPING);
  
  console.log(process.env.REACT_APP_TEMPLATE_DOWNLOAD);*/


  return (
<BrowserRouter basename={`${process.env.REACT_APP_DEPLOY_URL}`}>
    <Route render={() => (
      <Switch>
        <Route exact path="/"  component={PimaUpload} />
        {/* <Route exact path="/esg/products" component={ProdsVendorsFromSearch} />
        <Route exact path="/esg/:tileName/:category" component={FilterContentPage} /> */}

        {/* <Route path="*" component={NoRouteFound} /> */}
      </Switch>
    )}
    />
  </BrowserRouter>
  );
}

export default App;
